import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IClosedDays, IClosedDaysInput } from "@/interfaces/closed-days.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ClosedDaysService {
  private baseUrl = "api/v1/closeddays";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IClosedDays>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
  }

  async filter(
    filter: IFilter<IClosedDays>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IClosedDays>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, { filter });
  }

  async create(formData: IClosedDaysInput): Promise<void> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(id: number): Promise<IClosedDays> {
    return await httpRequest.get(`${this.baseUrl}/${id}`);
  }

  async update(formData: IClosedDaysInput, id: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${id}`, formData);
  }

  async delete(id: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${id}`);
  }
}

const closedDaysService = new ClosedDaysService();
export default closedDaysService;
